import UserAgreementRoutes from '@/root-app/app-routes/UserAgreementRoutes';
import { loaderRoute } from '@/root-app/app-routes/routes';
import AppRoutes from '@/root-app/app-routes/AppRoutes';
import AtaRoutes from '@/root-app/app-routes/AtaRoutes';
import { PORTAL_ROLES } from '@/authorization/authorization.constants';
import { UserAgreementResponse } from '@/users/services/usersApi';
import {
  LazyGetTriggerType,
  MutationTriggerType,
  responseHasError,
} from '@/core/network/network.utils';
import webStorage, { LOCAL_STORAGE_KEYS } from '@/core/web-storage/webStorage';
import { isEmployerUser, isValidPortalRole } from '@/authorization/utils/authorization.utils';
import { getBoardId, getUserId, getUserPortalRole } from '@/core/web-storage/webStorage.utils';
import EmployerUserRoutes from '@/root-app/app-routes/EmployerUserRoutes';
import tokens from '@/core/tokens.json';

export async function CheckUserAgreementStateAndRedirect(
  userId: string,
  userPortalRole: PORTAL_ROLES,
  getUserAgreementState: LazyGetTriggerType<string, UserAgreementResponse>,
  createDbUserFromAdUser: MutationTriggerType<string, UserAgreementResponse>,
  onSuccess: () => void,
  onFailure: () => void,
) {
  if (isEmployerUser(userPortalRole)) {
    await getUserAgreementState(userId)
      .then(async (userAgreementState) => {
        if (userAgreementState.isSuccess) {
          webStorage.local.setItem(
            LOCAL_STORAGE_KEYS.USER_AGREEMENT_STATE,
            userAgreementState?.data?.isUserAgreementValid.toString(),
          );
          onSuccess();
          window.location.reload();
        } else if (userAgreementState.isError) {
          await createDbUserFromAdUser(userId)
            .then((userAgreementState) => {
              webStorage.local.setItem(LOCAL_STORAGE_KEYS.USER_AGREEMENT_STATE, 'false');
              if (responseHasError(userAgreementState)) {
                onFailure();
              }
            })
            .catch(() => {
              onFailure();
            });
        }
      })
      .catch(() => {
        onFailure();
      });
  } else {
    onSuccess();
  }
}

export function getRouteForUserPortalRole(
  userPortalRole: PORTAL_ROLES,
  isUserAgreementAccepted: boolean | null,
) {
  switch (userPortalRole) {
    case PORTAL_ROLES.ATA:
      return [AtaRoutes];
    case PORTAL_ROLES.ATRF:
      return [AppRoutes];
    case PORTAL_ROLES.EMPLOYER_ADMIN:
      if (isUserAgreementAccepted === null) {
        return [loaderRoute];
      }
      return isUserAgreementAccepted ? [AppRoutes] : [UserAgreementRoutes];
    case PORTAL_ROLES.EMPLOYER_USER:
      if (isUserAgreementAccepted === null) {
        return [loaderRoute];
      }
      return isUserAgreementAccepted ? [EmployerUserRoutes] : [UserAgreementRoutes];
    default:
      return [loaderRoute];
  }
}

export function generateMinimalAppErrorMessage() {
  try {
    const userId = getUserId();
    const userBoardId = getBoardId();
    const userPortalRole = getUserPortalRole();

    if (!isValidPortalRole(userPortalRole)) {
      return tokens['ACCOUNT_PROBLEM'];
    }

    const missingElements = [];
    if (!userId) {
      missingElements.push(' user ID');
    }
    if (!userBoardId) {
      missingElements.push(' school board');
    }
    if (!userPortalRole) {
      missingElements.push(' portal role ');
    }

    return missingElements.length > 0
      ? 'This user does not have an assigned:' + missingElements
      : undefined;
  } catch {
    return undefined;
  }
}
